import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Skeleton from 'react-loading-skeleton'

import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sendEmail } from "store/actions";
import Loader from "Component/Common/Loader";
import useToastr from "helpers/toastr";
import { useTranslation } from 'react-i18next';
import ErrorMessage from "Component/Common/ErrorMessage";

const Joinus = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toastr = useToastr();
  const { t } = useTranslation();
  const [errorText, setErrorText] = useState();

  const { loading } = useSelector((state) => state?.JoinUs);

  const [fields, setFields] = useState({
    email: "",
  })

  const handleValidation = () => {
    let error = true;
    if (fields.email == "") {
      // toastr.error(t("email_required"))
      setErrorText(t('email_required'))
      error = false;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(fields.email)) {
      // toastr.error(t('enter_valid_email'))
      setErrorText(t('enter_valid_email'))
      error = false;
    }
    return error;
  }

  /**
     * Used for submit the join-us email
     */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (handleValidation()) {
      dispatch(sendEmail(fields, callback));
    }
  }

  const callback = (response) => {
    if (response.status == "success") {
      toastr.success(t('email_sent_successfully'));
      setFields({ ...fields, email: "" })
      setErrorText("")
    }
  }

  /**
     * Used for handle input states
     */
  const handleChange = (name) => (e) => {
    setFields(prev => ({ ...prev, [name]: e.target.value }));
  }


  const handleKeyDown = (e) => {
    if (e.keyCode === 32) {
      e.preventDefault();
    }

  }

  /**
     * Used for render the UI on home page for join us section
     */
  return (
    <section dir="ltr" className="Joinus_section">
      {loading && <Loader />}

      <Container>
        <Row>
          <Col lg={5} md={6} sm={12}>

            <div className="joinus_form text-start">

              <h2>            {t('joinUs_text')}
              </h2>
              <Form onSubmit={handleSubmit}>
                <FormGroup className="position-relative mt-5">
                  <Input
                    placeholder={t('email_placeholder')}
                    onChange={handleChange("email")}
                    value={fields?.email}
                    onKeyDown={handleKeyDown}


                  />
                  <Button type="submit" className="btn_submit rounded-pill border-0 px-3 py-2">
                    {t('submit')}
                  </Button>
                </FormGroup>
                {
                errorText &&
                <ErrorMessage errorText={errorText} />
              }
              </Form>
            

            </div>
          </Col>

          <Col lg={5} md={6} sm={12} className="offset-lg-2">
            <div className="Joinus_img">
              <img src="/images/joinus.png" alt="" className="img-fluid" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Joinus;
